import { useCallback } from 'react'

import { type CustomNode } from './types'

interface UseToggleExpandProps {
  setNodes: React.Dispatch<React.SetStateAction<CustomNode[]>>
}

const useToggleExpand = ({ setNodes }: UseToggleExpandProps) => {
  const onToggleExpand = useCallback(
    (nodeId: string) => {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === nodeId) {
            return {
              ...n,
              data: { ...n.data, expanded: !n.data.expanded },
            }
          }
          return n
        })
      )
    },
    [setNodes]
  )

  return { onToggleExpand }
}

export default useToggleExpand
